import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import JumboDemoCard from "@jumbo/components/JumboDemoCard/JumboDemoCard";
import { GetUpgradeRequestsReport } from "backendServices/ApiCalls";
import { useTranslation } from "react-i18next";

const Upgraderequestrejected = () => {
  const { t } = useTranslation();
  const [report, setReport] = useState([]);

  useEffect(() => {
    GetUpgradeRequestsReport(
      (response) => {
        const rejected = (response?.data?.data || []).filter((row) => row.status === "Rejected");
        setReport(rejected.map((row, index) => ({ ...row, index: index + 1 })));
      },
      () => {}
    );
  }, []);

  const columns = [
    { field: "index", headerName: "#", width: 60 },
    {
      field: "name",
      headerName: "Customer",
      width: 180,
      valueGetter: (params) =>
        `${params.row.firstname || ""} ${params.row.lastname || ""}`.trim() || "—",
    },
    { field: "email", headerName: "Email", width: 220 },
    { field: "plan", headerName: "Plan", width: 110 },
    { field: "period", headerName: "Period", width: 100 },
    { field: "reason", headerName: "Reason", width: 220, valueGetter: (p) => p.value || "—" },
    { field: "approved_by", headerName: "Rejected By", width: 150, valueGetter: (p) => p.value || "—" },
    {
      field: "approved_at",
      headerName: "Rejected At",
      width: 170,
      valueGetter: (p) => (p.value ? new Date(p.value).toLocaleString() : "N/A"),
    },
  ];

  return (
    <JumboDemoCard
      title={t("pages.title.upgraderequestrejected")}
      wrapperSx={{ backgroundColor: "background.paper", pt: 0 }}
    >
      <Box sx={{ height: 550, width: 1 }}>
        <DataGrid
          initialState={{ pagination: { paginationModel: { pageSize: 10 } } }}
          rows={report}
          getRowId={(row) => row.id}
          columns={columns}
          slots={{ toolbar: GridToolbar }}
          pageSizeOptions={[10, 25, 50]}
          slotProps={{ toolbar: { showQuickFilter: true, quickFilterProps: { debounceMs: 500 } } }}
        />
      </Box>
    </JumboDemoCard>
  );
};

export default Upgraderequestrejected;
